export var presets = {
  noWobble: {
    stiffness: 170,
    damping: 26
  },
  gentle: {
    stiffness: 120,
    damping: 14
  },
  wobbly: {
    stiffness: 180,
    damping: 12
  },
  stiff: {
    stiffness: 210,
    damping: 20
  }
};